(function(){'use strict';function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function () {};
      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}var log=function(){for(var e,t=arguments.length,r=new Array(t),n=0;n<t;n++)r[n]=arguments[n];return (e=console).log.apply(e,["[FreeGift]"].concat(r))},warn=function(){for(var e,t=arguments.length,r=new Array(t),n=0;n<t;n++)r[n]=arguments[n];return (e=console).warn.apply(e,["[FreeGift]"].concat(r))},FreeGiftCart=function(){function e(){_classCallCheck(this,e),this.isFreeGiftEnabled=e.isFeatureEnabled(),this.checkpoints=[],this.productCache=new Map,this.userOptedOut=new Map,this.giftsInCart=new Map,this.addingInProgress=new Set,this.removingInProgress=new Set,this.isRefreshing=!1,this.refreshTimeout=null,log("Constructor:",{enabled:this.isFreeGiftEnabled});}var t,r,n,i,a;return _createClass(e,[{key:"init",value:(a=_asyncToGenerator(_regeneratorRuntime().mark((function t(){var r,n,i,a=this;return _regeneratorRuntime().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(this.isFreeGiftEnabled){t.next=3;break}return warn("Feature disabled, exiting init"),t.abrupt("return");case 3:if(this.checkpoints=e.getCheckpoints(),0!==this.checkpoints.length){t.next=7;break}return warn("No free_product checkpoints found"),t.abrupt("return");case 7:return log("Found checkpoints:",this.checkpoints.map((function(e){return {id:e.id,threshold:(e.threshold/100).toFixed(2)+"€",handle:e.productHandle}}))),t.next=10,Promise.all(this.checkpoints.map((function(e){return a.fetchProduct(e.productHandle)})));case 10:r=this.checkpoints.filter((function(e){return a.productCache.has(e.productHandle)})).length,log("Product data loaded: ".concat(r,"/").concat(this.checkpoints.length)),n=this.handleCartChange.bind(this),i=this.handleCartRefresh.bind(this),document.documentElement.addEventListener("cart:change",n),document.addEventListener("cart:refresh",i),document.documentElement.addEventListener("cart:refresh",i),log("Event listeners registered (cart:change on documentElement, cart:refresh on both)"),log("Running initial cart check on page load..."),this.handleCartRefresh();case 20:case"end":return t.stop()}}),t,this)}))),function(){return a.apply(this,arguments)})},{key:"fetchProduct",value:(i=_asyncToGenerator(_regeneratorRuntime().mark((function e(t){var r,n,i,a;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!this.productCache.has(t)){e.next=3;break}return log("fetchProduct: Cache hit for",t),e.abrupt("return",this.productCache.get(t));case 3:return e.prev=3,log("fetchProduct: Fetching /products/"+t+".js ..."),e.next=7,fetch("/products/".concat(t,".js"));case 7:if((r=e.sent).ok){e.next=11;break}return warn("fetchProduct: HTTP error for",t,"— status:",r.status),e.abrupt("return",null);case 11:return e.next=13,r.json();case 13:if(n=e.sent,i=n.variants[0]){e.next=18;break}return warn("fetchProduct: No variants found for",t),e.abrupt("return",null);case 18:return a={id:n.id,handle:t,variantId:i.id,variantCount:n.variants.length},this.productCache.set(t,a),log("fetchProduct: Cached",t,"→",{productId:n.id,variantId:i.id,title:n.title,variantCount:n.variants.length}),e.abrupt("return",a);case 24:return e.prev=24,e.t0=e.catch(3),console.error("[FreeGift] fetchProduct: Network error for",t,e.t0),e.abrupt("return",null);case 28:case"end":return e.stop()}}),e,this,[[3,24]])}))),function(e){return i.apply(this,arguments)})},{key:"handleCartChange",value:function(t){var r;log("handleCartChange: Event received");var n=t.detail.cart;if(n){var i=null===(r=t.detail)||void 0===r?void 0:r.triggeredLineKey;if(i){var a=e.isFreeGiftLineKey(i);if(log("handleCartChange: triggeredLineKey =",i,"isFreeGift =",a),a)return void log("handleCartChange: Skipping — triggered by free gift line change")}var o=e.getCartTotal(n);log("handleCartChange:",{cartTotal:(o/100).toFixed(2)+"€",itemCount:n.items.length,items:n.items.map((function(e){var t,r;return {title:e.title,price:(e.final_line_price/100).toFixed(2)+"€",isFreeGift:(null===(t=e.properties)||void 0===t?void 0:t._free_gift)||"no",checkpointId:(null===(r=e.properties)||void 0===r?void 0:r._checkpoint_id)||"none",requiresShipping:e.requires_shipping}}))}),this.processCheckpoints(n,o);}else warn("handleCartChange: No cart data in event, returning");}},{key:"processCheckpoints",value:function(e,t){log("processCheckpoints: Evaluating ".concat(this.checkpoints.length," checkpoints against cart total ").concat((t/100).toFixed(2),"€"));var r,n=_createForOfIteratorHelper(this.checkpoints);try{for(n.s();!(r=n.n()).done;){var i=r.value,a=this.productCache.get(i.productHandle);if(a){var o=t>=i.threshold,s=this.findGiftInCart(e,a.id,i.id),c=this.giftsInCart.get(i.id)||!1,d=this.userOptedOut.get(i.id)||!1;log("processCheckpoints [".concat(i.id,"]:"),{handle:i.productHandle,threshold:(i.threshold/100).toFixed(2)+"€",cartTotal:(t/100).toFixed(2)+"€",isEligible:o,giftInCart:!!s&&s.key,wasInCart:c,isOptedOut:d}),o?s?(log("processCheckpoints [".concat(i.id,"]: ✓ Gift present in cart — tracking")),this.giftsInCart.set(i.id,!0)):c?(log("processCheckpoints [".concat(i.id,"]: ✗ Gift removed while eligible — user opted out")),this.userOptedOut.set(i.id,!0),this.giftsInCart.set(i.id,!1)):a.variantCount>1?log("processCheckpoints [".concat(i.id,"]: — Multi-variant product — skipping auto-add, user must pick via UI")):d||this.addingInProgress.has(i.id)?this.addingInProgress.has(i.id)?log("processCheckpoints [".concat(i.id,"]: ⏳ Add already in progress — skipping")):log("processCheckpoints [".concat(i.id,"]: — Skipping — user previously opted out")):(log("processCheckpoints [".concat(i.id,"]: → Eligible, not in cart, not opted out — auto-adding")),this.addFreeGiftToCart(a,i.id)):(d&&log("processCheckpoints [".concat(i.id,"]: ↻ Below threshold — resetting opt-out flag")),this.userOptedOut.set(i.id,!1),s?(log("processCheckpoints [".concat(i.id,"]: ✂ Below threshold — removing gift from cart (key: ").concat(s.key,")")),this.removeFreeGiftFromCart(s.key,i.id)):log("processCheckpoints [".concat(i.id,"]: ↓ Below threshold — gift not in cart, no action")),this.giftsInCart.set(i.id,!1));}else warn("processCheckpoints: Skipping checkpoint ".concat(i.id,' — product "').concat(i.productHandle,'" not in cache'));}}catch(e){n.e(e);}finally{n.f();}log("processCheckpoints: Done. State:",{giftsInCart:Object.fromEntries(this.giftsInCart),userOptedOut:Object.fromEntries(this.userOptedOut)});}},{key:"findGiftInCart",value:function(e,t,r){var n=e.items.find((function(e){var n,i;return e.product_id===t&&"true"===(null===(n=e.properties)||void 0===n?void 0:n._free_gift)&&(null===(i=e.properties)||void 0===i?void 0:i._checkpoint_id)===r}));return log("findGiftInCart:",{productId:t,checkpointId:r,found:!!n&&{key:n.key,title:n.title,variantId:n.variant_id}}),n}},{key:"handleCartRefresh",value:(n=_asyncToGenerator(_regeneratorRuntime().mark((function e(){var t=this;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(log("handleCartRefresh: Event received"),!this.isRefreshing){e.next=4;break}return log("handleCartRefresh: Skipped — already refreshing"),e.abrupt("return");case 4:this.refreshTimeout&&(log("handleCartRefresh: Clearing previous debounce timer"),clearTimeout(this.refreshTimeout)),log("handleCartRefresh: Debouncing 300ms..."),this.refreshTimeout=setTimeout(_asyncToGenerator(_regeneratorRuntime().mark((function e(){var r,n;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return t.isRefreshing=!0,log("handleCartRefresh: Fetching /cart.js ..."),e.prev=2,e.next=5,fetch("/cart.js",{headers:{"Content-Type":"application/json"}});case 5:if((r=e.sent).ok){e.next=8;break}throw new Error("HTTP error! status: ".concat(r.status));case 8:return e.next=10,r.json();case 10:n=e.sent,log("handleCartRefresh: Cart fetched:",{itemCount:n.items.length,total:(n.total_price/100).toFixed(2)+"€"}),t.handleCartChange({detail:{cart:n}}),e.next=18;break;case 15:e.prev=15,e.t0=e.catch(2),console.error("[FreeGift] handleCartRefresh: Error fetching cart data:",e.t0);case 18:return e.prev=18,t.isRefreshing=!1,log("handleCartRefresh: Done, isRefreshing = false"),e.finish(18);case 22:case"end":return e.stop()}}),e,null,[[2,15,18,22]])}))),300);case 7:case"end":return e.stop()}}),e,this)}))),function(){return n.apply(this,arguments)})},{key:"addFreeGiftToCart",value:(r=_asyncToGenerator(_regeneratorRuntime().mark((function e(t,r){var n,i,a,o,s;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!this.isRefreshing){e.next=3;break}return warn("addFreeGiftToCart: Skipped — currently refreshing"),e.abrupt("return");case 3:if(!this.addingInProgress.has(r)){e.next=6;break}return log("addFreeGiftToCart: Skipped — already adding for checkpoint",r),e.abrupt("return");case 6:return this.addingInProgress.add(r),n={items:[{id:t.variantId,quantity:1,properties:{_free_gift:"true",_checkpoint_id:r}}]},log("addFreeGiftToCart: POST /cart/add.js",{handle:t.handle,productId:t.id,variantId:t.variantId,checkpointId:r,payload:n}),e.prev=9,e.next=12,fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(n)});case 12:if(!(i=e.sent).ok){e.next=23;break}return e.next=16,i.json();case 16:o=e.sent,log("addFreeGiftToCart: Success for checkpoint",r,{addedItems:null===(a=o.items)||void 0===a?void 0:a.map((function(e){return {title:e.title,key:e.key,variantId:e.variant_id}}))}),this.giftsInCart.set(r,!0),log("addFreeGiftToCart: Dispatching cart:refresh in 100ms"),setTimeout((function(){document.dispatchEvent(new CustomEvent("cart:refresh",{bubbles:!0}));}),100),e.next=27;break;case 23:return e.next=25,i.text();case 25:s=e.sent,console.error("[FreeGift] addFreeGiftToCart: Failed —",i.status,s);case 27:e.next=32;break;case 29:e.prev=29,e.t0=e.catch(9),console.error("[FreeGift] addFreeGiftToCart: Network error —",e.t0);case 32:return e.prev=32,this.addingInProgress.delete(r),log("addFreeGiftToCart: Cleared addingInProgress for",r),e.finish(32);case 36:case"end":return e.stop()}}),e,this,[[9,29,32,36]])}))),function(e,t){return r.apply(this,arguments)})},{key:"removeFreeGiftFromCart",value:(t=_asyncToGenerator(_regeneratorRuntime().mark((function e(t,r){var n,i,a,o;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!this.removingInProgress.has(r)){e.next=3;break}return log("removeFreeGiftFromCart: Skipped — already removing for checkpoint",r),e.abrupt("return");case 3:return this.removingInProgress.add(r),log("removeFreeGiftFromCart: POST /cart/change.js",{lineKey:t,checkpointId:r}),e.prev=5,e.next=8,fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:t,quantity:0})});case 8:if(!(n=e.sent).ok){e.next=19;break}return e.next=12,n.json();case 12:a=e.sent,log("removeFreeGiftFromCart: Success for checkpoint",r,{itemCount:null===(i=a.items)||void 0===i?void 0:i.length,total:((a.total_price||0)/100).toFixed(2)+"€"}),this.giftsInCart.set(r,!1),log("removeFreeGiftFromCart: Dispatching cart:refresh in 100ms"),setTimeout((function(){document.dispatchEvent(new CustomEvent("cart:refresh",{bubbles:!0}));}),100),e.next=23;break;case 19:return e.next=21,n.text();case 21:o=e.sent,console.error("[FreeGift] removeFreeGiftFromCart: Failed —",n.status,o);case 23:e.next=28;break;case 25:e.prev=25,e.t0=e.catch(5),console.error("[FreeGift] removeFreeGiftFromCart: Network error —",e.t0);case 28:return e.prev=28,this.removingInProgress.delete(r),log("removeFreeGiftFromCart: Cleared removingInProgress for",r),e.finish(28);case 32:case"end":return e.stop()}}),e,this,[[5,25,28,32]])}))),function(e,r){return t.apply(this,arguments)})}],[{key:"getCheckpoints",value:function(){var e=document.querySelector("cart-progress-bar");if(!e)return warn("getCheckpoints: No cart-progress-bar element found in DOM"),[];try{var t=e.getAttribute("checkpoints-data")||"[]",r=JSON.parse(t);log("getCheckpoints: Raw checkpoint data parsed:",r.map((function(e){return {id:e.id,type:e.type,threshold:e.threshold,product_handle:e.product_handle||"(none)"}})));var n=r.filter((function(e){return "free_product"===e.type&&e.product_handle})).map((function(e){return {id:e.id,threshold:e.threshold,productHandle:e.product_handle}}));return log("getCheckpoints: Filtered ".concat(n.length," free_product checkpoints from ").concat(r.length," total")),n}catch(e){return console.error("[FreeGift] Error parsing checkpoints-data:",e),[]}}},{key:"getCartTotal",value:function(e){var t=e.items.filter((function(e){var t;return e.requires_shipping&&"true"!==(null===(t=e.properties)||void 0===t?void 0:t._free_gift)})).reduce((function(e,t){return e+t.final_line_price}),0),r=e.cart_level_discount_applications.reduce((function(e,t){return e+t.total_allocated_amount}),0);return log("getCartTotal:",{priceForItems:(t/100).toFixed(2)+"€",cartDiscount:(r/100).toFixed(2)+"€",result:((t-r)/100).toFixed(2)+"€"}),t-r}},{key:"isFeatureEnabled",value:function(){var e,t,r=!0===(null===(e=window.themeVariables)||void 0===e||null===(t=e.settings)||void 0===t?void 0:t.cartFreeGiftEnabled);return log("Feature enabled:",r),r}},{key:"isFreeGiftLineKey",value:function(e){var t=document.querySelector('[data-line-key="'.concat(e,'"]'));if(!t)return log("isFreeGiftLineKey:",e,"→ element not found in DOM"),!1;var r=t.hasAttribute("free-gift")||t.classList.contains("free-gift")||null!==t.closest("[free-gift]");return log("isFreeGiftLineKey:",e,"→",r),r}}]),e}();if(window.__freeGiftCartInit)warn("Already initialized — skipping duplicate script load");else {window.__freeGiftCartInit=!0;var initFreeGift=function(){var e=_asyncToGenerator(_regeneratorRuntime().mark((function e(){var t;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return log("Initializing..."),t=new FreeGiftCart,e.next=4,t.init();case 4:return window.__freeGiftCartInstance=t,log("Initialization complete"),e.abrupt("return",t);case 7:case"end":return e.stop()}}),e)})));return function(){return e.apply(this,arguments)}}();"loading"===document.readyState?document.addEventListener("DOMContentLoaded",initFreeGift):initFreeGift();}})();